import TextBlockDashboardWidget from './textBlockDashboardWidget';
import { ConstructorInput } from './dashboardWidgetFactory';

// const ns = 'app.services.headingDashboardWidget';

export type Configurations = { content: string };

export default class HeadingDashboardWidget extends TextBlockDashboardWidget {
  constructor(input: ConstructorInput) {
    super(input);
  }
}
